export default __webpack_public_path__ + "static/media/Staffs.31a702f9.svg";